import { WorkflowWebhookModel } from '@models/workflow-webhook.model';
import { WorkflowModel } from '@models/workflow.model';

export interface WebhookNodeData {
  webhookId: string;
  name: string;
  url?: string;
}

export interface WaitWebhookNodeData {
  webhookId: string;
  name: string;
  timeoutS: number;
  url?: string;
}

export interface ConditionNodeData {
  name: string;
  validations: WorkflowModel.Validation[];
}

export interface EchoNodeData {
  name: string;
}

export interface HttpRequestNodeData {
  httpRequestId: string;
  name: string;
  url?: string;
}

export interface AlertTriggerNodeData {
  eventId: string;
  name: string;
}

export interface WaitAlertNodeData {
  eventId: string;
  name: string;
  timeoutS?: number;
  historyWindowMs?: number;
  futureWindowMs?: number;
}

export interface SendSmsNodeData {
  name: string;
  orgUsersIds: string[];
  contactsIds: string[];
  message?: string;
}

export interface SendEmailNodeData {
  name: string;
  orgUsersIds: string[];
  contactsIds: string[];
  subject: string;
  body?: string;
}

export interface WaitSmsNodeData {
  name: string;
  timeoutS: number;
}

export interface WaitEmailNodeData {
  name: string;
  timeoutS: number;
}

export interface WaitNodeData {
  name: string;
  seconds: number;
}

export interface MobilePushNodeData {
  name: string;
  orgUserIds: string[];
  title: string;
  body: string;
}

export interface WaitMobilePushNodeData {
  name: string;
  timeoutS: number;
}

export interface VideoNodeData {
  date: string; // "2026-03-20T09:34:45.000Z"
  duration: number;
  name: string;
}

export interface GetImageNodeData {
  date: string; // "2026-03-20T09:34:45.000Z"
  name: string;
}

export interface SetFpsNodeData {
  fps: number;
  name: string;
}

export interface TrimNodeData {
  start: number;
  end: number;
  pad?: number;
  name: string;
}

export interface CropNodeData {
  scale: number;
  name: string;
}

export interface ResizeNodeData {
  factor: number;
  maxW: number;
  name: string;
}

export interface AiNodeData {
  promt: string;
  model: WorkflowModel.AiModels;
  name: string;
}

export interface ManualTriggerNodeData {
  name: string;
}

export interface ScheduleTriggerNodeData {
  name: string;
  interval: WorkflowModel.ScheduleIntervals;
  seconds?: number;
  minutes?: number;
  hours?: number;
  days?: number;
  weeks?: number;
  custom?: string;
  atMinute?: number;
  atHour?: WorkflowModel.AtHours;
  atDay?: WorkflowModel.Days;
}

export interface JsCodeNodeData {
  name: string;
  code: string;
}

export const OperatorsMap: Record<WorkflowModel.Operators, string> = {
  [WorkflowModel.Operators.Equal]: 'equal',
  [WorkflowModel.Operators.NotEqual]: 'not equal',
  [WorkflowModel.Operators.GreaterThan]: 'greater than',
  [WorkflowModel.Operators.GreaterThanOrEqual]: 'greater than or equal',
  [WorkflowModel.Operators.LessThan]: 'less than',
  [WorkflowModel.Operators.LessThanOrEqual]: 'less than or equal',
  [WorkflowModel.Operators.NotEmpty]: 'not empty',
};

export const HttpMethodsMap: Record<WorkflowModel.HttpMethods, string> = {
  [WorkflowModel.HttpMethods.POST]: 'POST',
  [WorkflowModel.HttpMethods.GET]: 'GET',
};

export enum WebhookTabs {
  QueryParams,
  Authorization,
  Body,
  Options,
}

export const authTypesMap: Record<
  WorkflowWebhookModel.WebhookAuthType,
  string
> = {
  [WorkflowWebhookModel.WebhookAuthType.NONE]: 'AUTH_TYPES.NO_AUTH',
  [WorkflowWebhookModel.WebhookAuthType.BASIC]: 'AUTH_TYPES.BASIC_AUTH',
  [WorkflowWebhookModel.WebhookAuthType.JWT]: 'AUTH_TYPES.BEARER_TOKEN',
};
